/* eslint-disable */
// i18n dictionary for UI strings (catalog content comes from backend)
export const TRANSLATIONS = {
  nl: {
    app_name: "Kiosk Configurator",
    tagline: "Alles-in-één kiosk-oplossingen voor jouw branche",
    nav: {
      home: "Home", configurator: "Configurator", catalog: "Catalogus",
      bundles: "Bundels", account: "Account", admin: "Admin",
      login: "Inloggen", register: "Registreren", logout: "Uitloggen",
      cart: "Winkelmand",
    },
    home: {
      hero_title: "Bouw je kiosk-oplossing op basis van je branche",
      hero_sub: "Geen producten-catalogus eerst, maar je gebruikscase. Kies je sector en toepassing en wij stellen de complete oplossing samen inclusief hardware, software en prijs.",
      cta_start: "Start configurator",
      cta_catalog: "Bekijk alle producten",
      pick_sector: "Kies je sector",
      pick_sector_sub: "We laten direct de best passende kiosken en software zien",
      bundles_title: "Aanbevolen pakketten",
      bundles_sub: "Kant-en-klare combinaties die vaak worden gekozen",
      how_title: "Zo werkt het",
      steps: [
        { t: "Kies sector", d: "Hospitality, leisure, retail, zorg of maatwerk" },
        { t: "Kies toepassing", d: "Bestellen, check-in, ticketing, toegang of info" },
        { t: "Wij raden aan", d: "Geschikte hardware + softwarebundels" },
        { t: "Klaar voor offerte", d: "PDF offerte of direct in de winkelmand" },
      ],
    },
    wizard: {
      step: "Stap", of: "van",
      s1: "Welke branche?", s2: "Welke toepassing?", s3: "Kies hardware",
      s4: "Stel software samen", s5: "Samenvatting & offerte",
      placement_indoor: "Binnen", placement_outdoor: "Buiten", placement_both: "Beide",
      vendor_all: "Alle leveranciers",
      next: "Volgende", back: "Terug", skip: "Overslaan",
      recommended: "Aanbevolen voor jou",
      best_practice: "Best-practice setup",
      add_to_cart: "Toevoegen", in_cart: "In mand",
      save_config: "Configuratie opslaan",
      pricing_buy: "Koop", pricing_lease: "Lease", pricing_sub: "Abonnement",
    },
    cart: {
      title: "Jouw configuratie",
      empty: "Je mand is nog leeg",
      one_time: "Eenmalig", monthly: "Per maand", total: "Totaal",
      checkout: "Offerte aanvragen", continue: "Verder winkelen",
      qty: "Aantal", remove: "Verwijder",
    },
    checkout: {
      title: "Offerte aanvragen",
      company: "Bedrijfsnaam", name: "Naam", email: "E-mail",
      phone: "Telefoon", country: "Land", notes: "Opmerkingen",
      submit: "Verstuur offerte aanvraag", success: "Offerte aangevraagd!",
      download: "Download PDF offerte",
    },
    auth: {
      login_title: "Inloggen", register_title: "Account aanmaken",
      email: "E-mail", password: "Wachtwoord",
      name: "Naam", company: "Bedrijf",
      submit_login: "Inloggen", submit_register: "Account aanmaken",
      no_account: "Nog geen account?", have_account: "Heb je al een account?",
      forgot: "Wachtwoord vergeten?",
      verify_title: "Bevestig je e-mail",
      verify_sub: "We hebben je een bevestigingslink gestuurd. Klik op de link om je account te activeren.",
      verify_button: "Bevestig",
      verified: "E-mail bevestigd! Je kunt nu alle functies gebruiken.",
      reset_title: "Wachtwoord resetten", new_password: "Nieuw wachtwoord",
      reset_submit: "Reset wachtwoord",
      dev_link: "Dev-link (mock email)",
    },
    account: {
      title: "Mijn account",
      orders: "Offertes", configs: "Opgeslagen configuraties", profile: "Profiel",
      no_orders: "Je hebt nog geen offertes aangevraagd",
      no_configs: "Nog geen opgeslagen configuraties",
    },
    admin: {
      title: "Admin CMS",
      dashboard: "Dashboard", hardware: "Hardware", software: "Software",
      bundles: "Bundels", addons: "Add-ons", vendors: "Leveranciers",
      sectors: "Sectoren", usecases: "Toepassingen",
      quotes: "Offertes", users: "Gebruikers", settings: "Instellingen",
      new: "Nieuw", edit: "Bewerken", delete: "Verwijder", save: "Opslaan", cancel: "Annuleer",
    },
    footer: "© 2025 Kiosk Configurator. Opgebouwd voor de recreatie- en hospitalitysector.",
  },
  en: {
    app_name: "Kiosk Configurator",
    tagline: "All-in-one kiosk solutions for your industry",
    nav: { home: "Home", configurator: "Configurator", catalog: "Catalog", bundles: "Bundles", account: "Account", admin: "Admin", login: "Log in", register: "Register", logout: "Log out", cart: "Cart" },
    home: {
      hero_title: "Build your kiosk solution based on your industry",
      hero_sub: "Not a product catalog first, but your use-case. Pick your sector and application, and we assemble the complete solution including hardware, software and pricing.",
      cta_start: "Start configurator", cta_catalog: "Browse all products",
      pick_sector: "Pick your sector",
      pick_sector_sub: "We instantly show the best-fit kiosks and software",
      bundles_title: "Recommended bundles",
      bundles_sub: "Ready-made combinations that are often chosen",
      how_title: "How it works",
      steps: [
        { t: "Pick sector", d: "Hospitality, leisure, retail, healthcare or custom" },
        { t: "Pick use-case", d: "Ordering, check-in, ticketing, access or info" },
        { t: "We recommend", d: "Matching hardware + software bundles" },
        { t: "Ready for quote", d: "PDF quote or add to cart directly" },
      ],
    },
    wizard: {
      step: "Step", of: "of",
      s1: "Which industry?", s2: "Which use-case?", s3: "Pick hardware",
      s4: "Stack software", s5: "Summary & quote",
      placement_indoor: "Indoor", placement_outdoor: "Outdoor", placement_both: "Both",
      vendor_all: "All vendors",
      next: "Next", back: "Back", skip: "Skip",
      recommended: "Recommended for you", best_practice: "Best-practice setup",
      add_to_cart: "Add", in_cart: "In cart",
      save_config: "Save configuration",
      pricing_buy: "Buy", pricing_lease: "Lease", pricing_sub: "Subscription",
    },
    cart: {
      title: "Your configuration",
      empty: "Your cart is empty",
      one_time: "One-time", monthly: "Monthly", total: "Total",
      checkout: "Request quote", continue: "Continue shopping",
      qty: "Qty", remove: "Remove",
    },
    checkout: {
      title: "Request quote",
      company: "Company", name: "Name", email: "Email", phone: "Phone",
      country: "Country", notes: "Notes",
      submit: "Submit quote request", success: "Quote requested!",
      download: "Download PDF quote",
    },
    auth: {
      login_title: "Log in", register_title: "Create account",
      email: "Email", password: "Password", name: "Name", company: "Company",
      submit_login: "Log in", submit_register: "Create account",
      no_account: "No account yet?", have_account: "Already have an account?",
      forgot: "Forgot password?",
      verify_title: "Verify your email",
      verify_sub: "We sent you a confirmation link. Click it to activate your account.",
      verify_button: "Verify",
      verified: "Email verified! You can now use all features.",
      reset_title: "Reset password", new_password: "New password", reset_submit: "Reset password",
      dev_link: "Dev link (mock email)",
    },
    account: {
      title: "My account",
      orders: "Quotes", configs: "Saved configurations", profile: "Profile",
      no_orders: "No quotes yet", no_configs: "No saved configurations yet",
    },
    admin: {
      title: "Admin CMS",
      dashboard: "Dashboard", hardware: "Hardware", software: "Software",
      bundles: "Bundles", addons: "Add-ons", vendors: "Vendors",
      sectors: "Sectors", usecases: "Use-cases",
      quotes: "Quotes", users: "Users", settings: "Settings",
      new: "New", edit: "Edit", delete: "Delete", save: "Save", cancel: "Cancel",
    },
    footer: "© 2025 Kiosk Configurator. Built for recreation & hospitality.",
  },
  de: {
    app_name: "Kiosk-Konfigurator",
    tagline: "All-in-One Kiosklösungen für Ihre Branche",
    nav: { home: "Home", configurator: "Konfigurator", catalog: "Katalog", bundles: "Pakete", account: "Konto", admin: "Admin", login: "Anmelden", register: "Registrieren", logout: "Abmelden", cart: "Warenkorb" },
    home: {
      hero_title: "Bauen Sie Ihre Kiosklösung auf Basis Ihrer Branche",
      hero_sub: "Kein Produkt-Katalog zuerst, sondern Ihr Use-Case. Wählen Sie Branche und Anwendung, und wir stellen die komplette Lösung zusammen.",
      cta_start: "Konfigurator starten", cta_catalog: "Alle Produkte ansehen",
      pick_sector: "Wählen Sie Ihre Branche",
      pick_sector_sub: "Wir zeigen sofort die am besten passenden Kioske und Software",
      bundles_title: "Empfohlene Pakete", bundles_sub: "Fertige Kombinationen, die oft gewählt werden",
      how_title: "So funktioniert es",
      steps: [
        { t: "Branche wählen", d: "Hospitality, Freizeit, Handel, Gesundheit oder Individuell" },
        { t: "Anwendung", d: "Bestellen, Check-in, Ticketing, Zutritt oder Info" },
        { t: "Wir empfehlen", d: "Passende Hardware + Software-Pakete" },
        { t: "Angebot", d: "PDF-Angebot oder direkt in den Warenkorb" },
      ],
    },
    wizard: {
      step: "Schritt", of: "von",
      s1: "Welche Branche?", s2: "Welche Anwendung?", s3: "Hardware wählen",
      s4: "Software stapeln", s5: "Zusammenfassung & Angebot",
      placement_indoor: "Innen", placement_outdoor: "Außen", placement_both: "Beides",
      vendor_all: "Alle Hersteller",
      next: "Weiter", back: "Zurück", skip: "Überspringen",
      recommended: "Für Sie empfohlen", best_practice: "Best-Practice-Setup",
      add_to_cart: "Hinzufügen", in_cart: "Im Warenkorb",
      save_config: "Konfiguration speichern",
      pricing_buy: "Kauf", pricing_lease: "Leasing", pricing_sub: "Abonnement",
    },
    cart: {
      title: "Ihre Konfiguration", empty: "Ihr Warenkorb ist leer",
      one_time: "Einmalig", monthly: "Monatlich", total: "Gesamt",
      checkout: "Angebot anfordern", continue: "Weiter einkaufen",
      qty: "Anz.", remove: "Entfernen",
    },
    checkout: {
      title: "Angebot anfordern", company: "Firma", name: "Name", email: "E-Mail",
      phone: "Telefon", country: "Land", notes: "Bemerkungen",
      submit: "Angebot anfragen", success: "Angebot angefragt!",
      download: "PDF-Angebot herunterladen",
    },
    auth: {
      login_title: "Anmelden", register_title: "Konto erstellen",
      email: "E-Mail", password: "Passwort", name: "Name", company: "Firma",
      submit_login: "Anmelden", submit_register: "Konto erstellen",
      no_account: "Noch kein Konto?", have_account: "Bereits ein Konto?",
      forgot: "Passwort vergessen?",
      verify_title: "E-Mail bestätigen",
      verify_sub: "Wir haben Ihnen einen Bestätigungslink gesendet. Klicken Sie zur Aktivierung.",
      verify_button: "Bestätigen",
      verified: "E-Mail bestätigt! Sie können jetzt alle Funktionen nutzen.",
      reset_title: "Passwort zurücksetzen", new_password: "Neues Passwort", reset_submit: "Zurücksetzen",
      dev_link: "Dev-Link (Mock-E-Mail)",
    },
    account: {
      title: "Mein Konto", orders: "Angebote", configs: "Gespeicherte Konfigurationen", profile: "Profil",
      no_orders: "Noch keine Angebote", no_configs: "Keine gespeicherten Konfigurationen",
    },
    admin: {
      title: "Admin CMS", dashboard: "Dashboard",
      hardware: "Hardware", software: "Software", bundles: "Pakete", addons: "Add-ons",
      vendors: "Hersteller", sectors: "Branchen", usecases: "Anwendungen",
      quotes: "Angebote", users: "Benutzer", settings: "Einstellungen",
      new: "Neu", edit: "Bearbeiten", delete: "Löschen", save: "Speichern", cancel: "Abbrechen",
    },
    footer: "© 2025 Kiosk-Konfigurator.",
  },
  fr: {
    app_name: "Configurateur Kiosque",
    tagline: "Solutions de kiosque tout-en-un pour votre secteur",
    nav: { home: "Accueil", configurator: "Configurateur", catalog: "Catalogue", bundles: "Packs", account: "Compte", admin: "Admin", login: "Connexion", register: "Inscription", logout: "Déconnexion", cart: "Panier" },
    home: {
      hero_title: "Construisez votre solution kiosque selon votre secteur",
      hero_sub: "Pas un catalogue produit d'abord, mais votre cas d'usage. Choisissez votre secteur et votre application, et nous assemblons la solution complète.",
      cta_start: "Démarrer le configurateur", cta_catalog: "Voir tous les produits",
      pick_sector: "Choisissez votre secteur",
      pick_sector_sub: "Nous montrons instantanément les kiosques et logiciels adaptés",
      bundles_title: "Packs recommandés", bundles_sub: "Combinaisons prêtes à l'emploi",
      how_title: "Comment ça marche",
      steps: [
        { t: "Secteur", d: "Hôtellerie, loisirs, retail, santé ou sur-mesure" },
        { t: "Cas d'usage", d: "Commande, check-in, billetterie, accès ou info" },
        { t: "Recommandations", d: "Hardware + logiciels adaptés" },
        { t: "Devis", d: "PDF ou ajouter au panier directement" },
      ],
    },
    wizard: {
      step: "Étape", of: "sur",
      s1: "Quel secteur?", s2: "Quel cas d'usage?", s3: "Choisir le matériel",
      s4: "Empiler les logiciels", s5: "Récap & devis",
      placement_indoor: "Intérieur", placement_outdoor: "Extérieur", placement_both: "Les deux",
      vendor_all: "Tous fournisseurs",
      next: "Suivant", back: "Retour", skip: "Passer",
      recommended: "Recommandé", best_practice: "Configuration type",
      add_to_cart: "Ajouter", in_cart: "Ajouté",
      save_config: "Enregistrer la configuration",
      pricing_buy: "Achat", pricing_lease: "Leasing", pricing_sub: "Abonnement",
    },
    cart: {
      title: "Votre configuration", empty: "Votre panier est vide",
      one_time: "Ponctuel", monthly: "Mensuel", total: "Total",
      checkout: "Demander un devis", continue: "Continuer",
      qty: "Qté", remove: "Retirer",
    },
    checkout: {
      title: "Demander un devis", company: "Société", name: "Nom", email: "Email",
      phone: "Téléphone", country: "Pays", notes: "Notes",
      submit: "Envoyer la demande", success: "Devis demandé!",
      download: "Télécharger le PDF",
    },
    auth: {
      login_title: "Connexion", register_title: "Créer un compte",
      email: "Email", password: "Mot de passe", name: "Nom", company: "Société",
      submit_login: "Se connecter", submit_register: "Créer le compte",
      no_account: "Pas encore de compte?", have_account: "Déjà un compte?",
      forgot: "Mot de passe oublié?",
      verify_title: "Vérifiez votre email",
      verify_sub: "Nous vous avons envoyé un lien. Cliquez pour activer.",
      verify_button: "Vérifier",
      verified: "Email vérifié! Vous pouvez utiliser toutes les fonctionnalités.",
      reset_title: "Réinitialiser", new_password: "Nouveau mot de passe", reset_submit: "Réinitialiser",
      dev_link: "Lien dev (email mock)",
    },
    account: {
      title: "Mon compte", orders: "Devis", configs: "Configurations", profile: "Profil",
      no_orders: "Aucun devis", no_configs: "Aucune configuration enregistrée",
    },
    admin: {
      title: "Admin CMS", dashboard: "Tableau de bord",
      hardware: "Matériel", software: "Logiciels", bundles: "Packs", addons: "Options",
      vendors: "Fournisseurs", sectors: "Secteurs", usecases: "Cas d'usage",
      quotes: "Devis", users: "Utilisateurs", settings: "Paramètres",
      new: "Nouveau", edit: "Modifier", delete: "Supprimer", save: "Enregistrer", cancel: "Annuler",
    },
    footer: "© 2025 Configurateur Kiosque.",
  },
  es: {
    app_name: "Configurador de Kioscos",
    tagline: "Soluciones de kiosco todo en uno para tu sector",
    nav: { home: "Inicio", configurator: "Configurador", catalog: "Catálogo", bundles: "Paquetes", account: "Cuenta", admin: "Admin", login: "Iniciar sesión", register: "Registrarse", logout: "Cerrar sesión", cart: "Carrito" },
    home: {
      hero_title: "Diseña tu solución de kiosco según tu sector",
      hero_sub: "No empezamos con el catálogo, sino con tu caso de uso. Elige tu sector y aplicación y armamos la solución completa con hardware, software y precio.",
      cta_start: "Iniciar configurador", cta_catalog: "Ver todos los productos",
      pick_sector: "Elige tu sector",
      pick_sector_sub: "Mostramos al instante los kioscos y software más adecuados",
      bundles_title: "Paquetes recomendados",
      bundles_sub: "Combinaciones listas frecuentemente elegidas",
      how_title: "Cómo funciona",
      steps: [
        { t: "Sector", d: "Hostelería, ocio, retail, sanidad o personalizado" },
        { t: "Caso de uso", d: "Pedidos, check-in, ticketing, acceso o info" },
        { t: "Recomendamos", d: "Hardware + paquetes de software a juego" },
        { t: "Listo para presupuesto", d: "PDF o añadir al carrito directamente" },
      ],
    },
    wizard: {
      step: "Paso", of: "de",
      s1: "¿Qué sector?", s2: "¿Qué caso de uso?", s3: "Elige hardware",
      s4: "Apila software", s5: "Resumen y presupuesto",
      placement_indoor: "Interior", placement_outdoor: "Exterior", placement_both: "Ambos",
      vendor_all: "Todos los proveedores",
      next: "Siguiente", back: "Atrás", skip: "Omitir",
      recommended: "Recomendado para ti", best_practice: "Configuración recomendada",
      add_to_cart: "Añadir", in_cart: "En carrito",
      save_config: "Guardar configuración",
      pricing_buy: "Comprar", pricing_lease: "Leasing", pricing_sub: "Suscripción",
    },
    cart: {
      title: "Tu configuración", empty: "Tu carrito está vacío",
      one_time: "Pago único", monthly: "Mensual", total: "Total",
      checkout: "Solicitar presupuesto", continue: "Seguir comprando",
      qty: "Cantidad", remove: "Eliminar",
    },
    checkout: {
      title: "Solicitar presupuesto",
      company: "Empresa", name: "Nombre", email: "Correo", phone: "Teléfono",
      country: "País", notes: "Notas",
      submit: "Enviar solicitud", success: "¡Presupuesto solicitado!",
      download: "Descargar PDF",
    },
    auth: {
      login_title: "Iniciar sesión", register_title: "Crear cuenta",
      email: "Correo", password: "Contraseña", name: "Nombre", company: "Empresa",
      submit_login: "Iniciar sesión", submit_register: "Crear cuenta",
      no_account: "¿Aún no tienes cuenta?", have_account: "¿Ya tienes cuenta?",
      forgot: "¿Olvidaste la contraseña?",
      verify_title: "Verifica tu correo",
      verify_sub: "Te enviamos un enlace de confirmación. Pulsa para activar la cuenta.",
      verify_button: "Verificar",
      verified: "¡Correo verificado!",
      reset_title: "Restablecer contraseña", new_password: "Nueva contraseña", reset_submit: "Restablecer",
      dev_link: "Enlace dev (correo simulado)",
    },
    account: {
      title: "Mi cuenta", orders: "Presupuestos", configs: "Configuraciones guardadas", profile: "Perfil",
      no_orders: "Aún no hay presupuestos", no_configs: "Aún no hay configuraciones guardadas",
    },
    admin: {
      title: "Admin CMS", dashboard: "Panel", hardware: "Hardware", software: "Software",
      bundles: "Paquetes", addons: "Accesorios", vendors: "Proveedores",
      sectors: "Sectores", usecases: "Casos de uso",
      quotes: "Presupuestos", users: "Usuarios", settings: "Ajustes",
      new: "Nuevo", edit: "Editar", delete: "Eliminar", save: "Guardar", cancel: "Cancelar",
    },
    footer: "© 2025 Configurador de Kioscos.",
  },
  it: {
    app_name: "Configuratore Kiosk",
    tagline: "Soluzioni kiosk all-in-one per il tuo settore",
    nav: { home: "Home", configurator: "Configuratore", catalog: "Catalogo", bundles: "Pacchetti", account: "Account", admin: "Admin", login: "Accedi", register: "Registrati", logout: "Esci", cart: "Carrello" },
    home: {
      hero_title: "Crea la tua soluzione kiosk in base al settore",
      hero_sub: "Non un catalogo prodotti, ma il tuo caso d'uso. Scegli il tuo settore e l'applicazione e montiamo la soluzione completa con hardware, software e prezzo.",
      cta_start: "Avvia configuratore", cta_catalog: "Vedi tutti i prodotti",
      pick_sector: "Scegli il tuo settore",
      pick_sector_sub: "Mostriamo subito kiosk e software più adatti",
      bundles_title: "Pacchetti consigliati",
      bundles_sub: "Combinazioni pronte spesso scelte",
      how_title: "Come funziona",
      steps: [
        { t: "Settore", d: "Hospitality, leisure, retail, sanità o personalizzato" },
        { t: "Caso d'uso", d: "Ordini, check-in, ticketing, accesso o info" },
        { t: "Consigliamo", d: "Hardware + pacchetti software corrispondenti" },
        { t: "Pronto per preventivo", d: "PDF o aggiungi al carrello" },
      ],
    },
    wizard: {
      step: "Passo", of: "di",
      s1: "Quale settore?", s2: "Quale caso d'uso?", s3: "Scegli hardware",
      s4: "Componi software", s5: "Riepilogo e preventivo",
      placement_indoor: "Interno", placement_outdoor: "Esterno", placement_both: "Entrambi",
      vendor_all: "Tutti i fornitori",
      next: "Avanti", back: "Indietro", skip: "Salta",
      recommended: "Consigliato per te", best_practice: "Setup consigliato",
      add_to_cart: "Aggiungi", in_cart: "Nel carrello",
      save_config: "Salva configurazione",
      pricing_buy: "Acquisto", pricing_lease: "Leasing", pricing_sub: "Abbonamento",
    },
    cart: {
      title: "La tua configurazione", empty: "Il tuo carrello è vuoto",
      one_time: "Una tantum", monthly: "Mensile", total: "Totale",
      checkout: "Richiedi preventivo", continue: "Continua acquisti",
      qty: "Quantità", remove: "Rimuovi",
    },
    checkout: {
      title: "Richiedi preventivo",
      company: "Azienda", name: "Nome", email: "Email", phone: "Telefono",
      country: "Paese", notes: "Note",
      submit: "Invia richiesta", success: "Preventivo richiesto!",
      download: "Scarica PDF",
    },
    auth: {
      login_title: "Accedi", register_title: "Crea account",
      email: "Email", password: "Password", name: "Nome", company: "Azienda",
      submit_login: "Accedi", submit_register: "Crea account",
      no_account: "Non hai ancora un account?", have_account: "Hai già un account?",
      forgot: "Password dimenticata?",
      verify_title: "Verifica la tua email",
      verify_sub: "Ti abbiamo inviato un link. Clicca per attivare il tuo account.",
      verify_button: "Verifica",
      verified: "Email verificata!",
      reset_title: "Reimposta password", new_password: "Nuova password", reset_submit: "Reimposta",
      dev_link: "Link dev (email mock)",
    },
    account: {
      title: "Il mio account", orders: "Preventivi", configs: "Configurazioni salvate", profile: "Profilo",
      no_orders: "Nessun preventivo", no_configs: "Nessuna configurazione salvata",
    },
    admin: {
      title: "Admin CMS", dashboard: "Dashboard", hardware: "Hardware", software: "Software",
      bundles: "Pacchetti", addons: "Accessori", vendors: "Fornitori",
      sectors: "Settori", usecases: "Casi d'uso",
      quotes: "Preventivi", users: "Utenti", settings: "Impostazioni",
      new: "Nuovo", edit: "Modifica", delete: "Elimina", save: "Salva", cancel: "Annulla",
    },
    footer: "© 2025 Configuratore Kiosk.",
  },
  da: {
    app_name: "Kiosk Konfigurator",
    tagline: "Alt-i-én kiosk-løsninger til din branche",
    nav: { home: "Hjem", configurator: "Konfigurator", catalog: "Katalog", bundles: "Pakker", account: "Konto", admin: "Admin", login: "Log ind", register: "Registrer", logout: "Log ud", cart: "Kurv" },
    home: {
      hero_title: "Byg din kiosk-løsning baseret på din branche",
      hero_sub: "Ikke et produktkatalog først, men dit anvendelsescase. Vælg din branche og anvendelse, og vi samler den komplette løsning med hardware, software og pris.",
      cta_start: "Start konfigurator", cta_catalog: "Se alle produkter",
      pick_sector: "Vælg din branche",
      pick_sector_sub: "Vi viser straks de bedst matchende kiosks og software",
      bundles_title: "Anbefalede pakker",
      bundles_sub: "Færdige kombinationer der ofte vælges",
      how_title: "Sådan virker det",
      steps: [
        { t: "Branche", d: "Hospitality, leisure, retail, sundhed eller skræddersyet" },
        { t: "Anvendelsescase", d: "Bestilling, check-in, billetter, adgang eller info" },
        { t: "Vi anbefaler", d: "Matchende hardware + software-pakker" },
        { t: "Klar til tilbud", d: "PDF eller læg i kurv" },
      ],
    },
    wizard: {
      step: "Trin", of: "af",
      s1: "Hvilken branche?", s2: "Hvilket anvendelsescase?", s3: "Vælg hardware",
      s4: "Stak software", s5: "Resumé og tilbud",
      placement_indoor: "Indendørs", placement_outdoor: "Udendørs", placement_both: "Begge",
      vendor_all: "Alle leverandører",
      next: "Næste", back: "Tilbage", skip: "Spring over",
      recommended: "Anbefalet til dig", best_practice: "Anbefalet opsætning",
      add_to_cart: "Tilføj", in_cart: "I kurv",
      save_config: "Gem konfiguration",
      pricing_buy: "Køb", pricing_lease: "Leasing", pricing_sub: "Abonnement",
    },
    cart: {
      title: "Din konfiguration", empty: "Din kurv er tom",
      one_time: "Engangsbetaling", monthly: "Månedligt", total: "Total",
      checkout: "Anmod om tilbud", continue: "Fortsæt indkøb",
      qty: "Antal", remove: "Fjern",
    },
    checkout: {
      title: "Anmod om tilbud",
      company: "Virksomhed", name: "Navn", email: "E-mail", phone: "Telefon",
      country: "Land", notes: "Bemærkninger",
      submit: "Send anmodning", success: "Tilbud anmodet!",
      download: "Download PDF",
    },
    auth: {
      login_title: "Log ind", register_title: "Opret konto",
      email: "E-mail", password: "Adgangskode", name: "Navn", company: "Virksomhed",
      submit_login: "Log ind", submit_register: "Opret konto",
      no_account: "Ingen konto endnu?", have_account: "Har du allerede en konto?",
      forgot: "Glemt adgangskode?",
      verify_title: "Bekræft din e-mail",
      verify_sub: "Vi har sendt et bekræftelseslink. Klik for at aktivere din konto.",
      verify_button: "Bekræft",
      verified: "E-mail bekræftet!",
      reset_title: "Nulstil adgangskode", new_password: "Ny adgangskode", reset_submit: "Nulstil",
      dev_link: "Dev link (mock e-mail)",
    },
    account: {
      title: "Min konto", orders: "Tilbud", configs: "Gemte konfigurationer", profile: "Profil",
      no_orders: "Ingen tilbud endnu", no_configs: "Ingen gemte konfigurationer",
    },
    admin: {
      title: "Admin CMS", dashboard: "Dashboard", hardware: "Hardware", software: "Software",
      bundles: "Pakker", addons: "Tilbehør", vendors: "Leverandører",
      sectors: "Brancher", usecases: "Anvendelsescases",
      quotes: "Tilbud", users: "Brugere", settings: "Indstillinger",
      new: "Ny", edit: "Rediger", delete: "Slet", save: "Gem", cancel: "Annuller",
    },
    footer: "© 2025 Kiosk Konfigurator.",
  },
};

export const CURRENCIES = [
  { code: "EUR", symbol: "€", label: "Euro" },
  { code: "USD", symbol: "$", label: "US Dollar" },
  { code: "GBP", symbol: "£", label: "British Pound" },
  { code: "CHF", symbol: "CHF", label: "Swiss Franc" },
];

export const LANGS = [
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "da", label: "Dansk", flag: "🇩🇰" },
];

// Pick a localized string from an *_i18n dict with graceful fallback,
// so missing translations (e.g. es/it/da) never render as blank text.
export const tr = (obj, lang) => {
  if (!obj || typeof obj !== "object") return obj || "";
  return obj[lang] || obj.en || obj.nl || obj.de || obj.fr || Object.values(obj).find(Boolean) || "";
};
